module.exports = __webpack_public_path__ + "static/media/spotlist.3e481ae5.png";